import HazardDateTimeDetails from "./hazardDateTimeDetails";

export default class HazardDescriptor extends HazardDateTimeDetails {
  id!: string;
  name!: string;
  description!: string;
}